// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import { Mutation, Query } from 'react-apollo'
import Loader from '../../../common/loader/Loader'
import { deleteMonthlyInfoLink, fetchMonthlyInfoLinks } from './linksQueries'
import { get } from 'lodash'
import { i18n } from '../../index'
import { Button, Typography } from '@mui/material'
import FileIcon from '@mui/icons-material/Description'
import css from './links.css'
import LinksModal from './LinksModal'
import DeleteButton from '../../../common/iconButtons/DeleteButton'
import withUser from '../../auth/withUser'
import type { Station } from '../../station/stationTypes'
import { getHttpUrl } from '../../../common/utils'
type LinkTypes = 'monthlyinfo_manager' | 'monthlyinfo_hall' | 'monthlyinfo_kitchen'
type LinksProps = {
  stationId: string
  linkType: LinkTypes
  companyId: string
}
type LinksState = {
  modalIsOpen: boolean
}
type Link = {
  station: Station | null
  fileName: string
  href: string
  id: string
}

@withUser
class Links extends React.Component<LinksProps, LinksState> {
  constructor() {
    super()
    this.state = {
      modalIsOpen: false,
    }
  }

  deleteLink = (e: Event, onMutate: (...args: Array<any>) => any, id: string) => {
    e.preventDefault()
    onMutate({
      variables: {
        id,
      },
    })
  }

  render() {
    const { stationId, user, linkType, companyId } = this.props
    const { modalIsOpen } = this.state
    return (
      <div className={css.component}>
        <LinksModal
          isOpen={modalIsOpen}
          onClose={() =>
            this.setState({
              modalIsOpen: false,
            })
          }
          stationId={stationId}
          linksType={linkType}
          companyId={companyId}
        />

        <Query
          query={fetchMonthlyInfoLinks}
          variables={{
            stationId,
            type: linkType,
          }}
        >
          {({ loading, error, data }) => {
            const links: Link[] = get(data, 'monthlyInfoLinks', [])
            return (
              <Loader
                {...{
                  loading,
                  error,
                }}
              >
                <Typography variant='h6' gutterBottom>
                  {i18n.t('monthlyInfo.title.links')}
                </Typography>
                {links && links.length > 0 && (
                  <div className={css.linksContainer}>
                    {links.map((link, i) => {
                      const canDelete = link.station !== null || user.userType === 'SokAdmin'
                      return (
                        <div key={i} className={css.link}>
                          <a href={getHttpUrl(link.href)} target={'_blank'} rel='noreferrer'>
                            <div className={css.linkContent}>
                              <FileIcon />

                              {link.fileName}

                              {canDelete && (
                                <Mutation
                                  mutation={deleteMonthlyInfoLink}
                                  refetchQueries={[
                                    {
                                      query: fetchMonthlyInfoLinks,
                                      variables: {
                                        stationId,
                                        type: linkType,
                                      },
                                    },
                                  ]}
                                >
                                  {(onMutate) => (
                                    <DeleteButton
                                      className={css.deleteButton}
                                      onClick={(e) => this.deleteLink(e, onMutate, link.id)}
                                    />
                                  )}
                                </Mutation>
                              )}
                            </div>
                          </a>
                        </div>
                      )
                    })}
                  </div>
                )}
              </Loader>
            )
          }}
        </Query>

        <div className={css.linksInputContainer}>
          <Button
            onClick={() =>
              this.setState({
                modalIsOpen: true,
              })
            }
            color={'primary'}
            variant='contained'
          >
            {i18n.t('monthlyInfo.button.addLinks')}
          </Button>
        </div>
      </div>
    )
  }
}

export default Links
